var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskFox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.413 4.95703L21.9209 14.2351L24.231 8.76117L34.413 4.95703Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57434 4.95703L17.9661 14.323L15.7689 8.76117L5.57434 4.95703Z",
    fill: "#E4761B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9184 26.4636L26.5913 31.5609L33.7099 33.5195L35.7564 26.5766L29.9184 26.4636Z",
    fill: "#E4761B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2561 26.5766L6.29 33.5195L13.4087 31.5609L10.0816 26.4636L4.2561 26.5766Z",
    fill: "#E4761B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0069 17.8509L11.0232 20.8516L18.0916 21.1654L17.8405 13.5697L13.0069 17.8509Z",
    fill: "#E4761B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9805 17.8509L22.0841 13.4818L21.9209 21.1654L28.9767 20.8516L26.9805 17.8509Z",
    fill: "#E4761B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4087 31.5609L17.6522 29.4894L13.9862 26.6268L13.4087 31.5609Z",
    fill: "#E4761B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3352 29.4894L26.5913 31.5609L26.0012 26.6268L22.3352 29.4894Z",
    fill: "#E4761B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5913 31.5609L22.3352 29.4894L22.6742 32.264L22.6365 33.4316L26.5913 31.5609Z",
    fill: "#D7C1B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4087 31.5609L17.3635 33.4316L17.3384 32.264L17.6522 29.4894L13.4087 31.5609Z",
    fill: "#D7C1B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4262 24.7938L13.8857 23.7518L16.3842 22.6093L17.4262 24.7938Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5612 24.7938L23.6032 22.6093L26.1142 23.7518L22.5612 24.7938Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4087 31.5609L14.0113 26.4636L10.0817 26.5766L13.4087 31.5609Z",
    fill: "#CD6116"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9888 26.4636L26.5914 31.5609L29.9185 26.5766L25.9888 26.4636Z",
    fill: "#CD6116"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9769 20.8516L21.921 21.1654L22.5739 24.7938L23.6159 22.6093L26.1269 23.7518L28.9769 20.8516Z",
    fill: "#CD6116"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8858 23.7518L16.3968 22.6093L17.4263 24.7938L18.0917 21.1654L11.0233 20.8516L13.8858 23.7518Z",
    fill: "#CD6116"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0232 20.8516L13.9862 26.6268L13.8857 23.7517L11.0232 20.8516Z",
    fill: "#E4751F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1268 23.7517L26.0012 26.6268L28.9767 20.8516L26.1268 23.7517Z",
    fill: "#E4751F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0916 21.1654L17.4261 24.7938L18.2548 29.075L18.4431 23.4378L18.0916 21.1654Z",
    fill: "#E4751F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9209 21.1654L21.5819 23.4253L21.7326 29.075L22.5737 24.7938L21.9209 21.1654Z",
    fill: "#E4751F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5737 24.7938L21.7325 29.075L22.3352 29.4893L26.0012 26.6268L26.1268 23.7517L22.5737 24.7938Z",
    fill: "#F6851B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8857 23.7517L13.9862 26.6268L17.6522 29.4893L18.2549 29.075L17.4262 24.7938L13.8857 23.7517Z",
    fill: "#F6851B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6366 33.4316L22.6742 32.264L22.3604 31.9878H17.6271L17.3384 32.264L17.3635 33.4316L13.4087 31.5609L14.7897 32.6908L17.5895 34.6368H22.398L25.2103 32.6908L26.5914 31.5609L22.6366 33.4316Z",
    fill: "#C0AD9E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3353 29.4894L21.7326 29.0751H18.2549L17.6523 29.4894L17.3384 32.264L17.6271 31.9878H22.3604L22.6742 32.264L22.3353 29.4894Z",
    fill: "#161616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9404 14.8377L36.0075 9.71534L34.4131 4.95703L22.3352 13.9212L26.9805 17.8509L33.5468 19.7718L35.0031 18.0769L34.3754 17.6249L35.3798 16.7084L34.6014 16.1058L35.6058 15.3399L34.9404 14.8377Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99243 9.71534L5.0596 14.8377L4.38163 15.3399L5.38603 16.1058L4.62018 16.7084L5.62457 17.6249L4.99683 18.0769L6.44064 19.7718L13.0069 17.8509L17.6522 13.9212L5.57435 4.95703L3.99243 9.71534Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5467 19.7719L26.9805 17.851L28.9767 20.8516L26.0012 26.6268L29.9183 26.5766H35.7563L33.5467 19.7719Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0069 17.851L6.44066 19.7719L4.2561 26.5766H10.0816L13.9862 26.6268L11.0232 20.8516L13.0069 17.851Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9209 21.1654L22.3352 13.9212L24.2435 8.76111H15.7689L17.6522 13.9212L18.0916 21.1654L18.2422 23.4504L18.2548 29.075H21.7325L21.7576 23.4504L21.9209 21.1654Z",
    fill: "#F6851B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskFox);
export default __webpack_public_path__ + "static/media/metamask-fox.5d21d940c453d84644ffbbd1753b3843.svg";
export { ForwardRef as ReactComponent };